import { PublicEnv } from "./env-types"

let store: PublicEnv | null = null

export function getEnv(): PublicEnv | null {
	return store
}

export function setEnv(env: PublicEnv): void {
	store = env
}
